module.exports = __webpack_public_path__ + "static/feel-good-foods-fc3df518c4c68e897e19e5bd7ab13d13.png";